<template>
  <div class="unit-manage">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right" @submit.native.prevent>
      <div style="max-width: 694px;">
        <el-form-item label-width="42px" label="地区：">
          <zwx-select-area ref="areaIdArea" @loadOver="areaIdLoadOver()" :zoneCode12From="zoneCode12From"
                           zoneTypeMax="0" :zoneTypeMin="zoneTypeMin" :showFullName="false" :disabled="false"
                           :clearable="false"/>
        </el-form-item>
        <el-form-item label-width="70px" label="机构名称：">
          <el-input class="zwx-input" v-model="mainForm.unitNameLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label-width="42px" label="状态：">
          <el-checkbox-group class="zwx-checkbox-group" v-model="mainForm.ifEnables">
            <el-checkbox class="zwx-checkbox" :label="true">启用</el-checkbox>
            <el-checkbox class="zwx-checkbox" :label="false">停用</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider"/>
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">查询
      </el-button>
      <el-button class="zwx-button zwx-button-icontext-28" icon="el-icon-plus" @click="add()"
                 v-if="$validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.fkByUnitId.fkByZoneId.zoneType < zoneTypeMin)">
        添加
      </el-button>
    </div>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" style="width: 100%;" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="fkByZoneId.fullName" label="地区"
                       :width="$system.calWidth(dataList, 'fkByZoneId.fullName', '地区')" header-align="left"
                       align="left"></el-table-column>
      <el-table-column prop="unitName" label="机构名称" :width="$system.calWidth(dataList, 'unitName', '机构名称')"
                       header-align="left" align="left"></el-table-column>
      <el-table-column prop="unitTypeSimpleCode.codeName" label="机构类型"
                       :width="$system.calWidth(dataList, 'unitTypeSimpleCode.codeName', '机构类型')" header-align="left"
                       align="left"></el-table-column>
      <el-table-column fixed="right" label="操作" :min-width="$system.calMinWidth({ wordNum: 8, arrowNum: 2, btnNum: 5 })"
                       header-align="left" align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="detail(scope.row)">查看
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="text" icon="el-icon-arrow-right"
                     @click="edit(scope.row)"
                     v-if="$validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.fkByUnitId.uid !== scope.row.uid)">
            编辑
          </el-button>
          <el-button class="zwx-button zwx-button-text-26"
                     :style="scope.row.ifEnable ? 'color: #e72b00 !important;' : ''" type="text"
                     @click="$system.msgbox(scope.row, '提示', scope.row.ifEnable ? '确定要停用吗？' : '确定要启用吗？', '确定', '取消', enable)"
                     v-if="$validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.fkByUnitId.uid !== scope.row.uid)">
            {{ scope.row.ifEnable ? '停用' : '启用' }}
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger"
                     @click="$system.msgbox(scope.row, '提示', '确定要删除吗？', '确定', '取消', deletion)"
                     v-if="!scope.row.ifEnable && $validate.checkbtns(btns[0]) && (users.ifSuperAdmin || users.fkByUnitId.uid !== scope.row.uid)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange"/>
  </div>
</template>

<script>
export default {
  name: 'UnitManage',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      unitTypeCodeTypeCode: this.$route.meta.unitTypeCodeTypeCode,
      btns: ['3c9b2933338666bc'],
      zoneCode12From: undefined,
      zoneTypeMin: '3',
      mainForm: {
        unitNameLike: '',
        ifEnables: [true],
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0,
    }
  },
  created() {
    this.zoneCode12From = this.users.ifSuperAdmin ? '000000000000' : this.users.fkByUnitId.fkByZoneId.zoneCode12
  },
  mounted() {
    this.$emit('loading', true)
    this.$refs.areaIdArea.initSearch()
  },
  activated() {
    if (this.$route.params.fresh) this.search(this.currentPage)
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.search(currentPage)
    },
    areaIdLoadOver() {
      this.search(this.currentPage)
    },
    search(currentPage) {
      this.$emit('loading', true)
      this.currentPage = currentPage
      let data = {
        currentPage: this.currentPage,
        areaId: this.$refs.areaIdArea.getChooseArea().rid,
        unitNameLike: this.mainForm.unitNameLike,
        ifEnable: this.mainForm.ifEnables.length === 1 ? this.mainForm.ifEnables[0] : null,
      }
      this.$system.get(this.api + '/systematic/getUnitList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.unitList
        this.total = data.unitCount
        this.pageSize = data.pageSize
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    enable(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid, ifEnable: !row.ifEnable}
      this.$system.post(this.api + '/systematic/modifyUnitState-1', data, true, true, this.enableSuccess, this.error)
    },
    enableSuccess(data) {
      if (data.type === '00') {
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    deletion(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid}
      this.$system.post(this.api + '/systematic/deleteUnit-1', data, true, true, this.deletionSuccess, this.error)
    },
    deletionSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    add() {
      this.$router.push({
        name: 'UnitEdit',
        params: {zoneTypeMin: this.zoneTypeMin, unitTypeCodeTypeCode: this.unitTypeCodeTypeCode}
      })
    },
    edit(row) {
      this.$router.push({
        name: 'UnitEdit',
        params: {rid: row.rid, zoneTypeMin: this.zoneTypeMin, unitTypeCodeTypeCode: this.unitTypeCodeTypeCode}
      })
    },
    detail(row) {
      this.$router.push({name: 'UnitDetail', params: {rid: row.rid}})
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
